import { createSlice } from '@reduxjs/toolkit';
import { loadingReactivationReducer } from './reducers/loading-reactivation.reducer';
import { updateReactivationReducer } from './reducers/update-reactivation.reducer';
import { reactivationErrorReducer } from './reducers/reactivation-error.reducer';
import { createCustomerReactivationReducer } from './reducers/create-reactivation.reducer';
import { initialReactivationState } from './state';

export const reactivationSlice = createSlice({
  name: 'Reactivation',
  initialState: initialReactivationState,
  reducers: {
    loading: loadingReactivationReducer,
    update: updateReactivationReducer,
    error: reactivationErrorReducer,
    create: createCustomerReactivationReducer,
  },
});

export const reactivationReducer = reactivationSlice.reducer;
